import { Box } from "@mui/material";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import { Card } from "./Card";
import { CurrencyExchangeIcon } from "./icons/CurrencyExchange";
import { ElectricMeterIcon } from "./icons/ElectricMeter";
import { OtherAdmissionIcon } from "./icons/OtherAdmission";
import { PriceCheckIcon } from "./icons/PriceCheck";
import { SolarPowerIcon } from "./icons/SolarPower";
import { ConfirmationNumberIcon } from "./icons/ConfirmationNumber";
import { CardsData } from "./types";
import { useMemo } from "react";
import { authUser$ } from "src/framework/components/navigations/MenuUser";
import { useObservable } from "src/framework/store/storeUtil";
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types";
import { CacheType, contaUsuario$ } from "src/store/global.store";
import { ContaUsuario } from "src/store/global.store.types";
import { TIPO_CONTA_INTEGRADOR } from "src/types";
import { DesignServicesIcon } from "./icons/DesignServices";

interface CardsContainerProps {
  valores: CardsData
  isLoading: boolean
}

const formatMoney = (value: number) => {
  return Formater.toString(value, TypeRecords.CURRENCY)
}

const formatStringLocale = (value: number) => {
  return value.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: Number.isInteger(value) ? 0 : 2 })
}

export const CardsContainer = ({ isLoading, valores: { comissionamento = 0, potenciaMediaGeradores = 0, potenciaTotalGeradores = 0, ticketMedio = 0, totalPropostas = 0, valorTotalGeradores = 0, valorServico = 0} }: CardsContainerProps) => {
  const authUser = useObservable<ExtraInfoUsuario | undefined>(authUser$)
  const contaUsuario = useObservable<CacheType<ContaUsuario | null>>(contaUsuario$)

  const isIntegradorSolar = useMemo(()=>{
    return contaUsuario?.data?.conta?.tipo_conta_id === TIPO_CONTA_INTEGRADOR
  },[contaUsuario])

  if (isLoading){
    return (
      <Box display="flex" alignItems={"center"} justifyContent={"center"} height={"150px"}>
        <span>Buscando...</span>
      </Box>
    )
  }
  
  return (
    <Box marginTop={"16px"} display={"grid"} gridTemplateColumns={"repeat(auto-fill, minmax(275px, 1fr))"} gap={"10px"}>
      <Card esconder={authUser?.isRevenda || isIntegradorSolar} bgColor="rgba(255, 238, 156, 0.30)" icone={<CurrencyExchangeIcon />} titulo="Valor do Distribuidor" valor={formatMoney(comissionamento)} />
      <Card bgColor="rgba(25, 152, 163, 0.20)" icone={<OtherAdmissionIcon /> } titulo="Total de propostas emitidas" valor={formatStringLocale(totalPropostas)} />
      <Card bgColor="rgba(255, 230, 230, 1)" icone={<ConfirmationNumberIcon />} titulo="Ticket médio por gerador" valor={formatMoney(ticketMedio)} />
      <Card bgColor="rgba(139, 230, 138, 0.30)" icone={<PriceCheckIcon />} titulo="Valor total dos geradores" valor={formatMoney(valorTotalGeradores)} />
      <Card bgColor="rgba(204, 143, 0, 0.30)" icone={<SolarPowerIcon />} titulo="Potência total dos geradores (kW)" valor={formatStringLocale(potenciaTotalGeradores)} />
      <Card bgColor="rgba(100, 211, 221, 0.30)" icone={<ElectricMeterIcon />} titulo="Potência média por gerador (kW)" valor={formatStringLocale(potenciaMediaGeradores)} />
      <Card esconder={!authUser?.isIntelbras && !authUser?.isRevenda && !isIntegradorSolar} bgColor="#E1BEE7" icone={<DesignServicesIcon />} titulo="Valor do serviço" valor={formatMoney(valorServico)} />
    </Box>
  );
}